import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Oauth2Service } from 'src/app/core/services';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(
    private oauth2Service: Oauth2Service,
    private httpClient: HttpClient
  ) {}

  onSignIn(jwtToken: string) {
    return this.oauth2Service.setProfile(jwtToken)
      .then(() => this.sso(jwtToken))
      .catch((error) => {
        this.oauth2Service.signOut();
        throw error;
      });
  }

  sso(jwtToken: string) {
    const apiUrl = environment.api + 'auth/sso';
    const headers = new HttpHeaders().set('X-Auth-Token', jwtToken);

    return this.httpClient
      .get(apiUrl, { headers })
      .toPromise()
      .then((response: any) => {
        const modifiedToken = response?.token || jwtToken;
        this.oauth2Service.setAuthToken(modifiedToken);
        return this.oauth2Service.updateProfile(response);
      });
  }
}
